import { render, staticRenderFns } from "./callInfo.vue?vue&type=template&id=3d977f60&"
import script from "./callInfo.vue?vue&type=script&lang=js&"
export * from "./callInfo.vue?vue&type=script&lang=js&"
import style0 from "./callInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports